import state from './state'
import mutations from './mutations'
import actions from './actions'

const project = {
  state,
  mutations,
  actions
}

export default project



// WEBPACK FOOTER //
// ./src/store/dsahboard/index.js